/*       */

export default `
        id
        name
        type
`;
